import React, { useContext, useEffect, useRef, useState } from 'react';
import { Grid } from '@mui/material';
import BakeasyCheckbox from '../../components/common/BakeasyCheckbox';
import BakeasyHeaderLabel from '../../components/labels/BakeasyHeaderLabel';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  BakeasyImgSelector,
  BakeasyImgSelectorView,
} from '../../components/common/BakeasyImgSelect';
import BakeasySwitch from '../../components/common/BakeasySwitch';
import {
  BILL_TO_ARRAY,
  BILL_TO_ARRAY_WITHOUT_CHAINSTORE,
  STATUS_ARRAY,
  SUPPLIER_CATEGORY_ARRAY,
} from '../../constants/Constants';
import { t } from 'i18next';
import dayjs, { Dayjs } from 'dayjs';
import { useAppDispatch, useAppSelector } from '../../redux_store/reduxStore';
import {
  addSupplier,
  clearSupplierState,
  downloadSupplierDetails,
  fetchSupplierById,
  modifySupplier,
  suppliersState,
} from '../../redux_store/slices/suppliersSlice';
import { BakeasyAppBar } from '../../components/layouts/BakeasyAppBar';
import BakeasyDivider from '../../components/common/BakeasyDivider';
import BakeasyDatePicker from '../../components/common/BakeasyDatePicker';
import { uploadFile } from '../../ApiServices/SupplierServices';
import * as TextField from '../../components/textfields/BakeasyTextFields';
import * as Button from '../../components/buttons/BakeasyButtons';
import * as Dropdown from '../../components/dropdowns/BakeasySelect';
import { AppContext } from '../../context/AppContext';
import BakeasyPaper from '../../components/common/BakesasyPaper';
import BakeasyLabelText from '../../components/labels/BakeasyLabelText';
import * as Regex from '../../constants/Regex';
import {
  prepareMobileNumber,
  preparePostalCode,
  validateField,
} from '../../utils/ValidationUtils';
import {
  clearTaxesState,
  fetchTaxes,
  taxesState,
} from '../../redux_store/slices/taxesSlice';
import { BakeasyAutoCompleteTax } from '../../components/dropdowns/BakeasyAutoCompleteTax';
import {
  BakeasyAutoCompleteCountry,
  BakeasyAutoCompletePaymentMethod,
  BakeasyAutoCompletePaymentTerms,
  BakeasyAutoCompleteSetupFee,
  BakeasyAutoCompleteState,
  BakeasyAutoCompleteSubscriptionPack,
} from '../../components/dropdowns/BakeasySelectAutoComplete';
import {
  countryState,
  fetchCountries,
} from '../../redux_store/slices/countriesSlice';
import {
  clearStatesState,
  fetchStates,
  statesState,
} from '../../redux_store/slices/statesSlice';
import { dropdownDataState } from '../../redux_store/slices/dropdownDataSlice';
import i18n from '../../languages/languages';
import { hideLoader, showLoader } from '../../redux_store/slices/loaderSlice';

export const AddEditSupplier = (props: any) => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useAppDispatch();
  let myContext = useContext(AppContext);
  const formRef = useRef<HTMLDivElement>(null);

  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [isView, setIsView] = useState<boolean>(false);
  const [supplierData, setSupplierData] = useState<any>();

  const [registrationDate, setRegistrationDate] = useState<Dayjs | null>(null);
  const [selectedLanguage, setSelectedLanguage] = useState<string>('');
  const [accountingCode, setAccountingCode] = useState<any>('');
  const [selectedCategory, setSelectedCategory] = useState<any>('B2B');
  const [supplierID, setSupplierID] = useState<any>('');
  const [supplierName, setSupplierName] = useState<any>('');
  const [userName, setUserName] = useState<any>('');
  const [password, setPassword] = useState<any>('');
  const [legalName, setLegalName] = useState<any>('');
  const [differentLegalName, setDifferentLegalName] = useState<any>(
    i18n.language === 'fr' ? 'Non' : 'No'
  );
  const [supplierAddress, setSupplierAddress] = useState<any>('');
  const [supplierCity, setSupplierCity] = useState<any>('');
  const [supplierState, setSupplierState] = useState<any>(null);
  const [supplierPostCode, setSupplierPostCode] = useState<any>('');
  const [supplierCountry, setSupplierCountry] = useState<any>(null);
  const [supplierEmail, setSupplierEmail] = useState<any>('');
  const [supplierWork, setSupplierWork] = useState<any>('');
  const [adminTax1, setAdminTax1] = useState<any>('');
  const [adminTax2, setAdminTax2] = useState<any>('');

  const [contactOneFirstName, setContactOneFirstName] = useState<any>('');
  const [contactOneLastName, setContactOneLastName] = useState<any>('');
  const [contactOneEmail, setContactOneEmail] = useState<any>('');
  const [contactOneWork, setContactOneWork] = useState<any>('');
  const [contactOneMobile, setContactOneMobile] = useState<any>('');

  const [contactTwoFirstName, setContactTwoFirstName] = useState<any>('');
  const [contactTwoLastName, setContactTwoLastName] = useState<any>('');
  const [contactTwoEmail, setContactTwoEmail] = useState<any>('');
  const [contactTwoWork, setContactTwoWork] = useState<any>('');
  const [contactTwoMobile, setContactTwoMobile] = useState<any>('');

  const [accountingFirstName, setAccountingFirstName] = useState<any>('');
  const [accountingLastName, setAccountingLastName] = useState<any>('');
  const [accountingEmail, setAccountingEmail] = useState<any>('');
  const [accountingWork, setAccountingWork] = useState<any>('');
  const [accountingMobile, setAccountingMobile] = useState<any>('');

  const [isChainStore, setIsChainStore] = useState<boolean>(false);
  const [chainStoreName, setChainStoreName] = useState<any>('');
  //const [billTo, setBillTo] = useState<any>('');
  const [parentAddress, setParentAddress] = useState<any>('');
  const [parentCity, setParentCity] = useState<any>('');
  const [parentState, setParentState] = useState<any>(null);
  const [parentPostCode, setParentPostCode] = useState<any>('');
  const [parentCountry, setParentCountry] = useState<any>(null);
  const [parentEmailId, setParentEmailId] = useState<any>('');
  const [parentWork, setParentWork] = useState<any>('');

  const [recipeBuilder, setRecipeBuilder] = useState<any>(false);
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState<any>('');
  const [selectedBillTo, setSelectedBillTo] = useState<any>('');
  const [billToName, setBillToName] = useState<any>('');
  const [billToCompanyName, setBillToCompanyName] = useState<any>('');
  const [billToAddress, setBillToAddress] = useState<any>('');
  const [billToCity, setBillToCity] = useState<any>('');
  const [billToPostCode, setBillToPostCode] = useState<any>('');
  const [billToCountry, setBillToCountry] = useState<any>(null);
  const [billToState, setBillToState] = useState<any>(null);

  const [selectedPaymentTerm, setSelectedPaymentTerm] = useState<any>('');
  const [selectedBillingSetupFee, setSelectedBillingSetupFee] =
    useState<any>('');
  const [selectedBillingSubscriptionPack, setSelectedBillingSubscriptionPack] =
    useState<any>('');

  const [selectedtaxrateOne, setSelectedtaxrateOne] = useState<any>('');
  const [selectedtaxrateTwo, setSelectedtaxrateTwo] = useState<any>('');
  const [selectedStatus, setSelectedStatus] = useState<any>('');
  const [description, setDescription] = useState<any>('');

  const [selectedSupplierLogoFile, setSelectedSupplierLogoFile] = useState<
    File | string | null
  >(null);

  let { error, selectedValue } = useAppSelector(suppliersState);
  let _taxesState = useAppSelector(taxesState);
  let _countryState = useAppSelector(countryState);
  let _statesState = useAppSelector(statesState);
  let _dropdownDataState = useAppSelector(dropdownDataState);

  useEffect(() => {
    setIsEdit(location?.state?.isEdit);
    setIsView(location?.state?.isView);

    if (location?.state?.isEdit === true || location?.state?.isView === true) {
      fetchData(location?.state?._id);
    }

    dispatch(fetchCountries({ page: 1, limit: 5, search: '' }));
  }, []);

  useEffect(() => {
    if (error) {
      navigate(-1);
    }
  }, [error]);

  useEffect(() => {
    if (selectedValue) {
      setSupplierData(selectedValue);
      setData(selectedValue);
    }
  }, [selectedValue]);

  const fetchData = async (_id: any) => {
    try {
      await dispatch(fetchSupplierById({ id: _id }));
    } catch (error) {}
  };

  async function setData(data: any) {
    setRegistrationDate(dayjs(data?.createdDate));
    setAccountingCode(data?.accountingCode);
    setSelectedLanguage(data?.defaultLanguage);
    setSelectedCategory(data?.supplierCategory);
    setSupplierID(data?.supplierNumber);
    setSupplierName(data?.supplierName);
    setUserName(data?.userName);
    setLegalName(data?.legalName);
    setSupplierAddress(data?.supplierAddress?.address1);
    setSupplierCity(data?.supplierAddress?.city);
    if (data?.legalName && data?.legalName !== data?.storeName) {
      setDifferentLegalName(i18n.language === 'fr' ? 'Oui' : 'Yes');
    } else {
      setDifferentLegalName(i18n.language === 'fr' ? 'Non' : 'No');
    }
    if (
      data?.supplierAddress?.country &&
      _countryState?.value?.data?.length > 0
    ) {
      let temp: any = _countryState.value?.data?.find(
        (item: any) => item?.countryName === data?.supplierAddress?.country
      );

      if (temp !== undefined) {
        setSupplierCountry(temp);
        await dispatch(
          fetchStates({ page: 1, limit: 100, countryId: temp?._id })
        );
        await dispatch(
          fetchTaxes({ page: 1, limit: 10, countryId: temp?._id })
        );
      } else {
        setSupplierCountry(
          data?.supplierAddress?.country
            ? { countryName: data?.supplierAddress?.country }
            : null
        );

        if (data?.supplierAddress?.country) {
          await dispatch(
            fetchStates({
              page: 1,
              limit: 100,
              countryId: data?.supplierAddress?._id,
            })
          );
          await dispatch(
            fetchTaxes({
              page: 1,
              limit: 10,
              countryId: data?.supplierAddress?._id,
            })
          );
        }
      }
    }

    setSupplierState(
      data?.supplierAddress?.state
        ? { stateName: data?.supplierAddress?.state }
        : null
    );
    setSupplierPostCode(data?.supplierAddress?.zipCode);
    setSupplierEmail(data?.supplierEmail);
    setSupplierWork(data?.supplierWork);
    setAdminTax1(data?.adminTax1);
    setAdminTax2(data?.adminTax2);

    setContactOneFirstName(data?.contact1?.firstName);
    setContactOneLastName(data?.contact1?.lastName);
    setContactOneEmail(data?.contact1?.email);
    setContactOneWork(data?.contact1?.work);
    setContactOneMobile(data?.contact1?.mobile);

    setContactTwoFirstName(data?.contact2?.firstName);
    setContactTwoLastName(data?.contact2?.lastName);
    setContactTwoEmail(data?.contact2?.email);
    setContactTwoWork(data?.contact2?.work);
    setContactTwoMobile(data?.contact2?.mobile);

    setAccountingFirstName(data?.contactAccounting?.firstName);
    setAccountingLastName(data?.contactAccounting?.lastName);
    setAccountingEmail(data?.contactAccounting?.email);
    setAccountingWork(data?.contactAccounting?.work);
    setAccountingMobile(data?.contactAccounting?.mobile);

    setIsChainStore(Boolean(data?.chainStore));
    setChainStoreName(data?.chainStoreDetail?.chainStoreName);
    //setBillTo(data?.chainStoreDetail?.billTo);
    setParentAddress(data?.chainStoreDetail?.parentAddress);
    setParentCity(data?.chainStoreDetail?.parentCity);
    setParentPostCode(data?.chainStoreDetail?.parentPostCode);
    setParentCountry(
      data?.chainStoreDetail?.parentCountry
        ? { countryName: data?.chainStoreDetail?.parentCountry }
        : null
    );
    setParentState(
      data?.chainStoreDetail?.parentState
        ? { stateName: data?.chainStoreDetail?.parentState }
        : null
    );
    setParentEmailId(data?.chainStoreDetail?.parentEmailId);
    setParentWork(data?.chainStoreDetail?.parentWork);

    setSelectedBillTo(data?.billTo);
    setBillToName(data?.billToInfo?.name);
    setBillToCompanyName(data?.billToInfo?.companyName);
    setBillToAddress(data?.billToInfo?.companyAddress);
    setBillToCity(data?.billToInfo?.city);
    setBillToState(
      data?.billToInfo?.state ? { stateName: data?.billToInfo?.state } : null
    );
    setBillToCountry(
      data?.billToInfo?.country
        ? { countryName: data?.billToInfo?.country }
        : null
    );
    setBillToPostCode(data?.billToInfo?.zipCode);

    setSelectedPaymentMethod(
      data?.payment?.method
        ? { paymentMethod: { ...data?.payment?.method } }
        : null
    );

    setSelectedPaymentTerm(
      data?.payment?.terms
        ? { paymentTerms: { ...data?.payment?.terms } }
        : null
    );

    setSelectedBillingSetupFee(
      data?.billing?.setUpFee
        ? { setupFee: { ...data?.billing?.setUpFee } }
        : null
    );
    setSelectedBillingSubscriptionPack(
      data?.billing?.subscriptionPack
        ? { subscriptionPack: { ...data?.billing?.subscriptionPack } }
        : null
    );

    setSelectedtaxrateOne(
      data?.taxes?.rate1 ? { taxName: data?.taxes?.rate1 } : null
    );
    setSelectedtaxrateTwo(
      data?.taxes?.rate2 ? { taxName: data?.taxes?.rate2 } : null
    );

    setSelectedStatus(data?.status);
    setRecipeBuilder(data?.recipeBuilder);

    setDescription(data?.description);
    setSelectedSupplierLogoFile(data.supplierLogo);
  }

  const checkValidity = (): boolean => {
    // if (!validateField(dispatch, 'ACCOUNTING_CODE', accountingCode, Regex.accountingCode)) {
    //   return false;
    // }

    if (
      accountingCode !== undefined &&
      accountingCode !== '' &&
      !validateField(
        dispatch,
        'ACCOUNTING_CODE',
        accountingCode,
        formRef,
        Regex.accountingCode
      )
    ) {
      return false;
    }

    // if (!validateField(dispatch, 'LANGUAGE', selectedLanguage)) {
    //   return false;
    // }

    if (!validateField(dispatch, 'CATEGORY', selectedCategory, formRef)) {
      return false;
    }

    if (
      !validateField(
        dispatch,
        'SUPPLIER_NAME',
        supplierName,
        formRef,
        Regex.name
      )
    ) {
      return false;
    }

    if (
      !validateField(dispatch, 'USERNAME', userName, formRef, Regex.username)
    ) {
      return false;
    }

    if (!isEdit) {
      if (!validateField(dispatch, 'PASSWORD', password, formRef)) {
        return false;
      }
    }
    // if (!password && !isEdit) {
    //   let msg = `${t('PASSWORD')} ${t('IS_REQUIRED')}`;
    //   dispatch(showErrorSnackbar({ message: msg }));
    //   return false;
    // }

    // if (
    //   differentLegalName !== 'No'  &&
    //   !validateField(dispatch, 'LEGAL_NAME', legalName, formRef, Regex.name)
    // ) {
    //   return false;
    // }
    if (
      differentLegalName !== 'No' &&
      differentLegalName !== 'Non' &&
      !validateField(dispatch, 'LEGAL_NAME', legalName, formRef, Regex.name)
    ) {
      return false;
    }

    if (
      !validateField(
        dispatch,
        'SUPPLIER_COUNTRY',
        supplierCountry?.countryName,
        formRef,
        Regex.onlyAlphabets
      )
    ) {
      return false;
    }

    if (
      !validateField(
        dispatch,
        'SUPPLIER_STATE_PROVINCE',
        supplierState?.stateName,
        formRef,
        Regex.onlyAlphabets
      )
    ) {
      return false;
    }

    if (
      !validateField(dispatch, 'SUPPLIER_ADDRESS', supplierAddress, formRef)
    ) {
      return false;
    }

    if (
      !validateField(
        dispatch,
        'SUPPLIER_CITY',
        supplierCity,
        formRef,
        Regex.onlyAlphabets
      )
    ) {
      return false;
    }

    // if (!validateField(dispatch, 'SUPPLIER_POSTAL_CODE', supplierPostCode, Regex.postCode)) {
    //   return false;
    // }

    if (
      !validateField(
        dispatch,
        'SUPPLIER_POSTAL_CODE',
        supplierPostCode,
        formRef,
        supplierCountry?.countryName === 'USA'
          ? Regex.usaPostCode
          : Regex.canadaPostCode
      )
    ) {
      return false;
    }

    if (
      !validateField(
        dispatch,
        'SUPPLIER_EMAIL',
        supplierEmail,
        formRef,
        Regex.emailId
      )
    ) {
      return false;
    }

    if (
      !validateField(
        dispatch,
        'SUPPLIER_WORK',
        supplierWork,
        formRef,
        Regex.mobile
      )
    ) {
      return false;
    }

    if (
      !validateField(
        dispatch,
        'FIRST_NAME',
        contactOneFirstName,
        formRef,
        Regex.name
      )
    ) {
      return false;
    }

    if (
      !validateField(
        dispatch,
        'LAST_NAME',
        contactOneLastName,
        formRef,
        Regex.name
      )
    ) {
      return false;
    }

    if (
      !validateField(
        dispatch,
        'EMAIL_ID',
        contactOneEmail,
        formRef,
        Regex.emailId
      )
    ) {
      return false;
    }

    // if (!validateField(dispatch, 'MOBILE', contactOneMobile, Regex.mobile)) {
    //   return false;
    // }
    if (
      contactOneMobile !== undefined &&
      contactOneMobile !== '' &&
      contactOneMobile !== null &&
      !validateField(
        dispatch,
        'MOBILE',
        contactOneMobile,
        formRef,
        Regex.mobile
      )
    ) {
      return false;
    }

    if (
      !validateField(dispatch, 'WORK', contactOneWork, formRef, Regex.mobile)
    ) {
      return false;
    }

    if (
      contactTwoFirstName !== undefined &&
      contactTwoFirstName !== '' &&
      !validateField(
        dispatch,
        'FIRST_NAME',
        contactTwoFirstName,
        formRef,
        Regex.name
      )
    ) {
      return false;
    }
    // if (!contactTwoFirstName || !ValidateInput(Regex.name, contactTwoFirstName)) {
    //   let msg = `${t('FIRST_NAME')} ${t('IS_REQUIRED')}`;
    //   dispatch(showErrorSnackbar({ message: msg }));
    //   return false;
    // }
    if (
      contactTwoLastName !== undefined &&
      contactTwoLastName !== '' &&
      !validateField(
        dispatch,
        'LAST_NAME',
        contactTwoLastName,
        formRef,
        Regex.name
      )
    ) {
      return false;
    }
    // if (!contactTwoLastName || !ValidateInput(Regex.name, contactTwoLastName)) {
    //   let msg = `${t('LAST_NAME')} ${t('IS_REQUIRED')}`;
    //   dispatch(showErrorSnackbar({ message: msg }));
    //   return false;
    // }
    if (
      contactTwoEmail !== undefined &&
      contactTwoEmail !== '' &&
      !validateField(
        dispatch,
        'EMAIL_ID',
        contactTwoEmail,
        formRef,
        Regex.emailId
      )
    ) {
      return false;
    }
    // if (!contactTwoEmail || !ValidateInput(Regex.emailId, contactTwoEmail)) {
    //   let msg = `${t('EMAIL')} ${t('IS_REQUIRED')}`;
    //   dispatch(showErrorSnackbar({ message: msg }));
    //   return false;
    // }

    if (
      contactTwoMobile !== undefined &&
      contactTwoMobile !== '' &&
      contactTwoMobile !== null &&
      !validateField(
        dispatch,
        'MOBILE',
        contactTwoMobile,
        formRef,
        Regex.mobile
      )
    ) {
      return false;
    }
    // if (!contactTwoMobile || !ValidateMobile(contactTwoMobile)) {
    //   let msg = `${t('MOBILE')} ${t('IS_REQUIRED')}`;
    //   dispatch(showErrorSnackbar({ message: msg }));
    //   return false;
    // }

    if (
      contactTwoWork !== undefined &&
      contactTwoWork !== '' &&
      contactTwoWork !== null &&
      !validateField(dispatch, 'WORK', contactTwoWork, formRef, Regex.mobile)
    ) {
      return false;
    }
    // if (!contactTwoWork || !ValidateMobile(contactTwoWork)) {
    //   let msg = `${t('MOBILE')} ${t('IS_REQUIRED')}`;
    //   dispatch(showErrorSnackbar({ message: msg }));
    //   return false;
    // }

    if (
      accountingFirstName !== undefined &&
      accountingFirstName !== '' &&
      !validateField(
        dispatch,
        'FIRST_NAME',
        accountingFirstName,
        formRef,
        Regex.name
      )
    ) {
      return false;
    }
    // if (!validateField(dispatch, 'FIRST_NAME', accountingFirstName, Regex.)) {
    //   return false;
    // }
    if (
      accountingLastName !== undefined &&
      accountingLastName !== '' &&
      !validateField(
        dispatch,
        'LAST_NAME',
        accountingLastName,
        formRef,
        Regex.name
      )
    ) {
      return false;
    }
    // if (!validateField(dispatch, 'LAST_NAME', accountingLastName, Regex.name)) {
    //   return false;
    // }
    if (
      accountingEmail !== undefined &&
      accountingEmail !== '' &&
      !validateField(
        dispatch,
        'EMAIL_ID',
        accountingEmail,
        formRef,
        Regex.emailId
      )
    ) {
      return false;
    }
    // if (!validateField(dispatch, 'EMAIL', accountingEmail, Regex.emailId)) {
    //   return false;
    // }

    if (
      accountingMobile !== undefined &&
      accountingMobile !== '' &&
      accountingMobile !== null &&
      !validateField(
        dispatch,
        'MOBILE',
        accountingMobile,
        formRef,
        Regex.mobile
      )
    ) {
      return false;
    }
    // if (!validateField(dispatch, 'MOBILE', accountingMobile, Regex.mobile)) {
    //   return false;
    // }

    if (
      accountingWork !== undefined &&
      accountingWork !== '' &&
      accountingWork !== null &&
      !validateField(dispatch, 'WORK', accountingWork, formRef, Regex.mobile)
    ) {
      return false;
    }
    // if (!validateField(dispatch, 'MOBILE', accountingWork, Regex.mobile)) {
    //   return false;
    // }
    if (isChainStore) {
      if (
        !validateField(
          dispatch,
          'CHAIN_STORE_NAME',
          chainStoreName,
          formRef,
          Regex.name
        )
      ) {
        return false;
      }
      if (
        !validateField(
          dispatch,
          'PARENT_COUNTRY',
          parentCountry?.countryName,
          formRef,
          Regex.onlyAlphabets
        )
      ) {
        return false;
      }
      if (
        !validateField(
          dispatch,
          'PARENT_STATE',
          parentState?.stateName,
          Regex.onlyAlphabets
        )
      ) {
        return false;
      }

      if (
        !validateField(
          dispatch,
          'PARENT_CITY',
          parentCity,
          formRef,
          Regex.onlyAlphabets
        )
      ) {
        return false;
      }

      if (!validateField(dispatch, 'PARENT_ADDRESS', parentAddress, formRef)) {
        return false;
      }

      if (
        !validateField(
          dispatch,
          'PARENT_POSTAL_CODE',
          parentPostCode,
          formRef,
          parentCountry?.countryName === 'USA'
            ? Regex.usaPostCode
            : Regex.canadaPostCode
        )
      ) {
        return false;
      }

      if (
        !validateField(
          dispatch,
          'PARENT_EMAIL_ID',
          parentEmailId,
          formRef,
          Regex.emailId
        )
      ) {
        return false;
      }
      if (
        !validateField(
          dispatch,
          'PARENT_WORK_NUMBER',
          parentWork,
          formRef,
          Regex.mobile
        )
      ) {
        return false;
      }
    }

    if (!validateField(dispatch, 'BILL_TO', selectedBillTo, formRef)) {
      return false;
    }
    if (
      !validateField(dispatch, 'BILL_TO_NAME', billToName, formRef, Regex.name)
    ) {
      return false;
    }
    if (
      !validateField(
        dispatch,
        'COMPANY_NAME',
        billToCompanyName,
        formRef,
        Regex.name
      )
    ) {
      return false;
    }
    // if (!billToAddress) {
    //   let msg = `${t('ADDRESS')} ${t('IS_REQUIRED')}`;
    //   dispatch(showErrorSnackbar({ message: msg }));
    //   return false;
    // }

    if (
      !validateField(
        dispatch,
        'BILL_TO_COUNTRY',
        billToCountry?.countryName,
        formRef,
        Regex.onlyAlphabets
      )
    ) {
      return false;
    }
    if (
      !validateField(
        dispatch,
        'STATE',
        billToState?.stateName,
        formRef,
        Regex.onlyAlphabets
      )
    ) {
      return false;
    }
    if (
      !validateField(dispatch, 'CITY', billToCity, formRef, Regex.onlyAlphabets)
    ) {
      return false;
    }
    if (!validateField(dispatch, 'COMPANY_ADDRESS', billToAddress, formRef)) {
      return false;
    }
    // if (!validateField(dispatch, 'POSTAL_CODE', billToPostCode, Regex.postCode)) {
    //   return false;
    // }

    if (
      !validateField(
        dispatch,
        'POSTAL_CODE',
        billToPostCode,
        formRef,
        billToCountry?.countryName === 'USA'
          ? Regex.usaPostCode
          : Regex.canadaPostCode
      )
    ) {
      return false;
    }

    if (!validateField(dispatch, 'METHOD', selectedPaymentMethod, formRef)) {
      return false;
    }
    if (!validateField(dispatch, 'TERMS', selectedPaymentTerm, formRef)) {
      return false;
    }
    if (
      !validateField(dispatch, 'SETUP_FEE', selectedBillingSetupFee, formRef)
    ) {
      return false;
    }
    if (
      !validateField(
        dispatch,
        'SUBSCRIPTION_PACK',
        selectedBillingSubscriptionPack,
        formRef
      )
    ) {
      return false;
    }
    if (
      !validateField(dispatch, 'SUPPLIER_TAX1', selectedtaxrateOne, formRef)
    ) {
      return false;
    }
    if (
      !validateField(dispatch, 'SUPPLIER_TAX2', selectedtaxrateTwo, formRef)
    ) {
      return false;
    }
    if (!validateField(dispatch, 'STATUS', selectedStatus, formRef)) {
      return false;
    }
    // if (!validateField(dispatch, 'RECIPE_BUILDER', recipeBuilder)) {
    //   return false;
    // }
    // if (!validateField(dispatch, 'DESCRIPTION', description)) {
    //   return false;
    // }

    return true;
  };

  async function onSubmit() {
    if (!checkValidity()) {
      return;
    }

    if (supplierData && supplierData?.status !== selectedStatus) {
      if (selectedStatus === 'Active') {
        myContext.setConfirmDialog({
          type: 'reActivate',
          open: true,
          title: t('REACTIVATE_SUPPLIER'),
          message: t('REACTIVATE_SUPPLIER_MESSAGE'),
          onYesClick: (event: any, param: any) => {
            if (param === true) {
              handleAddEditSupplier();
            }
          },
        });
      } else {
        myContext.setConfirmDialog({
          type: 'deActivate',
          open: true,
          title: t('DEACTIVATE_SUPPLIER'),
          message: t('DEACTIVATE_SUPPLIER_MESSAGE'),
          onYesClick: (event: any, param: any) => {
            if (param === true) {
              handleAddEditSupplier();
            }
          },
        });
      }
    } else {
      handleAddEditSupplier();
    }
  }

  function openConfirmDialogMesssageValidation() {
    myContext.setConfirmDialog({
      open: true,
      type: 'confirm-validation-message',
      title: t('CONFIRMATION'),
      message: t(
        'YOU_MUST_COMPLETE_ALL_REQUIRED_FEILDS_OR_CHANGES_WILL_BE_LOST'
      ),
      onNoClick: (event: any) => {},
      onYesClick: (event: any, param: string | undefined) => {
        navigate(-1);
      },
    });
  }

  function setBillToData(billToValue: string) {
    switch (billToValue) {
      case 'ChainStore':
        if (isChainStore) {
          setBillToName(chainStoreName);
          setBillToCompanyName(chainStoreName);
          setBillToAddress(parentAddress);
          setBillToCity(parentCity);
          setBillToState(parentState);
          setBillToCountry(parentCountry);
          setBillToPostCode(parentPostCode);
        } else {
          clearBillTo();
        }
        break;
      case 'Supplier':
        setBillToName(supplierName);
        setBillToCompanyName(supplierName);
        setBillToAddress(supplierAddress);
        setBillToCity(supplierCity);
        setBillToState(supplierState);
        setBillToCountry(supplierCountry);
        setBillToPostCode(supplierPostCode);
        break;
      case 'Other':
        clearBillTo();
        break;
    }
  }

  function handleChainStoreCheck(isChainStoreChecked: boolean) {
    if (!isChainStoreChecked) {
      setChainStoreName('');
      setParentAddress('');
      setParentCity('');
      setParentState('');
      setParentPostCode('');
      setParentCountry('');
      setParentEmailId('');
      setParentWork('');
    }
    if (!isChainStoreChecked && selectedBillTo === 'ChainStore') {
      clearBillTo();
    }
  }

  function clearBillTo() {
    setBillToName('');
    setBillToCompanyName('');
    setBillToAddress('');
    setBillToCity('');
    setBillToState('');
    setBillToCountry('');
    setBillToPostCode('');
  }

  async function handleAddEditSupplier() {
    let supplierLogoUrl = undefined;
    if (selectedSupplierLogoFile instanceof File) {
      dispatch(showLoader({ message: t('UPLOADING_LOGO') }));
      supplierLogoUrl = await uploadFile(
        selectedSupplierLogoFile,
        'supplierLogo'
      );
      dispatch(hideLoader());
    }

    let payload = {
      accountingCode: accountingCode,
      defaultLanguage: selectedLanguage === '' ? 'English' : selectedLanguage,
      supplierCategory: selectedCategory,
      supplierName: supplierName,
      userName: userName,
      legalName:
        differentLegalName === 'Yes' || differentLegalName === 'Oui'
          ? legalName
          : supplierName,
      adminTax1: adminTax1,
      adminTax2: adminTax2,
      supplierEmail: supplierEmail,
      supplierWork: supplierWork,
      supplierAddress: {
        address1: supplierAddress,
        city: supplierCity,
        state: supplierState?.stateName,
        zipCode: supplierPostCode,
        country: supplierCountry?.countryName,
      },
      contact1: {
        firstName: contactOneFirstName ?? '',
        lastName: contactOneLastName ?? '',
        email: contactOneEmail ?? '',
        mobile: contactOneMobile ? contactOneMobile?.toString() : '',
        work: contactOneWork ? contactOneWork?.toString() : '',
      },
      contact2: {
        firstName: contactTwoFirstName ?? '',
        lastName: contactTwoLastName ?? '',
        email: contactTwoEmail ?? '',
        mobile: contactTwoMobile ? contactTwoMobile?.toString() : '',
        work: contactTwoWork ? contactTwoWork?.toString() : '',
      },
      contactAccounting: {
        firstName: accountingFirstName,
        lastName: accountingLastName,
        email: accountingEmail,
        mobile: accountingMobile ? accountingMobile?.toString() : '',
        work: accountingWork ? accountingWork?.toString() : '',
      },
      chainStore: isChainStore,
      billTo: selectedBillTo,
      billToInfo: {
        name: billToName,
        companyName: billToCompanyName,
        companyAddress: billToAddress,
        city: billToCity,
        zipCode: billToPostCode,
        state: billToState?.stateName,
        country: billToCountry?.countryName,
      },
      payment: {
        method: {
          ...selectedPaymentMethod?.paymentMethod,
          createdDate: undefined, // Remove  explicitly
          modifiedDate: undefined, // Remove  explicitly
        },
        terms: {
          ...selectedPaymentTerm?.paymentTerms,
          createdDate: undefined, // Remove  explicitly
          modifiedDate: undefined, // Remove  explicitly}
        },
      },
      billing: {
        setUpFee: {
          ...selectedBillingSetupFee?.setupFee,
          createdDate: undefined, // Remove  explicitly
          modifiedDate: undefined, // Remove  explicitly}
        },
        subscriptionPack: {
          ...selectedBillingSubscriptionPack?.subscriptionPack,
          createdDate: undefined, // Remove  explicitly
          modifiedDate: undefined, // Remove  explicitly}
        },
      },
      taxes: {
        rate1: selectedtaxrateOne?.taxName,
        rate2: selectedtaxrateTwo?.taxName,
      },
      status: selectedStatus,
      recipeBuilder: recipeBuilder,
      description: description,
    };

    let detailsPayload = {};
    if (supplierLogoUrl !== undefined) {
      detailsPayload = { ...payload, logoId: supplierLogoUrl.data.id };
    } else {
      detailsPayload = { ...payload };
    }

    if (isChainStore) {
      detailsPayload = {
        ...detailsPayload,
        chainStoreDetail: {
          chainStoreName: chainStoreName,
          parentAddress: parentAddress,
          parentCity: parentCity,
          parentState: parentState?.stateName,
          parentPostCode: parentPostCode,
          parentCountry: parentCountry?.countryName,
          parentEmailId: parentEmailId,
          parentWork: parentWork ? parentWork?.toString() : '',
        },
      };
    }
    if (isEdit) {
      let newPayload: any = { ...detailsPayload, id: location?.state?._id };
      if (password !== '') {
        newPayload = { ...newPayload, password: password };
      }

      let response: any = await dispatch(modifySupplier(newPayload));
      if (response?.payload?.status === 200) {
        dispatch(clearSupplierState());
        navigate(-1);
      }
    } else {
      let newPayload = { ...detailsPayload, password: password };
      let response: any = await dispatch(addSupplier(newPayload));
      if (response?.payload?.status === 200) {
        dispatch(clearSupplierState());
        navigate(-1);
      }
    }
  }

  function openAddTaxDialog(data: any) {
    return myContext.setDialog({
      open: true,
      title: 'ADD_TAX',
      dialogContent: {
        pageName: 'AddTax',
        params: { ...data, supplierCountry },
        onBack: async () => {
          await dispatch(
            fetchTaxes({ page: 1, limit: 10, countryId: supplierCountry?._id })
          );
        },
      },
    });
  }

  function openImageDialog(pageName: string, title: string, imgUrl: any) {
    return myContext.setDialog({
      open: true,
      title,
      dialogContent: { pageName, imgUrl, title },
    });
  }

  function getMenus() {
    return (
      <Grid>
        {isView && (
          <div className="tableOptions">
            <Button.Edit
              onClick={(event: any) => {
                setIsEdit(true);
                setIsView(false);
              }}
            />

            <Button.Export
              onClick={function (
                event: React.MouseEvent<HTMLButtonElement, MouseEvent>
              ): void {
                dispatch(
                  downloadSupplierDetails({
                    id: location?.state?._id,
                    downloadType: 'csv',
                  })
                );
              }}
            />

            <Button.Print
              onClick={async function (
                event: React.MouseEvent<HTMLButtonElement, MouseEvent>
              ): Promise<void> {
                await dispatch(
                  downloadSupplierDetails({
                    id: location?.state?._id,
                    downloadType: 'pdf',
                  })
                );
              }}
            />
          </div>
        )}
      </Grid>
    );
  }

  async function handleSupplierCountrySelect(country: any) {
    setSupplierState(null);
    setSelectedtaxrateOne(null);
    setSelectedtaxrateTwo(null);
    dispatch(clearStatesState());
    dispatch(clearTaxesState());

    if (country === undefined || country === null) {
      setSupplierCountry(null);
      return;
    }

    setSupplierCountry(country);
    let payload: any = { page: 1, limit: 100, countryId: country?._id };
    await dispatch(fetchStates(payload));
    await dispatch(fetchTaxes(payload));
  }

  async function handleParentCountrySelect(country: any) {
    setParentState(null);
    dispatch(clearStatesState());

    if (country === undefined || country === null) {
      setParentCountry(null);
      return;
    }

    setParentCountry(country);
    let payload: any = { page: 1, limit: 100, countryId: country?._id };
    await dispatch(fetchStates(payload));
  }

  async function handleBillToCountrySelect(country: any) {
    setBillToState(null);
    dispatch(clearStatesState());

    if (country === undefined || country === null) {
      setBillToCountry(null);
      return;
    }

    setBillToCountry(country);
    let payload: any = { page: 1, limit: 100, countryId: country?._id };
    await dispatch(fetchStates(payload));
  }

  function getRegexPatternForPostalCode(country: string): RegExp {
    if (country === 'Canada') {
      return Regex.canadaPostCode;
    } else if (country === 'USA') {
      return Regex.usaPostCode;
    }
    return Regex.canadaPostCode;
  }

  function getMaxLengthForPostalCode(country: string): number {
    if (country === 'Canada') {
      return 7;
    } else if (country === 'USA') {
      return 10;
    }
    return 7;
  }

  function addSupplierUI() {
    return (
      <div ref={formRef}>
        <Grid>
          <Grid item sx={{ marginBottom: 1 }}>
            <BakeasyAppBar
              title={t(
                isEdit
                  ? 'EDIT_SUPPLIER'
                  : isView
                    ? 'SUPPLIER_DETAILS'
                    : 'ADD_SUPPLIER'
              )}
              onBackClick={() => {
                openConfirmDialogMesssageValidation();
              }}
              menus={getMenus()}
            />
          </Grid>

          <BakeasyPaper>
            <Grid
              sx={{
                display: 'flex',
                marginLeft: '1',
                justifyContent: 'space-between',
              }}
            >
              <Grid container>
                <BakeasyHeaderLabel message={t('SUPPLIER_DETAILS')} />
              </Grid>

              {/* {isEdit && (
							<Grid
								container
								sx={{ alignItems: "center", justifyContent: "end" }}
							>
								<BakeasyChipDeactive onClick={() => {}} />
								<BakeasyChipDelete onClick={() => {}} />
							</Grid>
						)} */}
            </Grid>

            <Grid container spacing={2} pl={2}>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyDatePicker
                  label={t('DATE_REGISTERED')}
                  value={
                    registrationDate ? registrationDate : dayjs(new Date())
                  }
                  disabled={true}
                  required={true}
                />
              </Grid>

              {(isEdit || isView) && (
                <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                  <TextField.SupplierId disabled={true} value={supplierID} />
                </Grid>
              )}

              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <TextField.AccountingCode
                  disabled={isView}
                  value={accountingCode}
                  onChange={(event: any) => {
                    setAccountingCode(event?.target?.value);
                  }}
                  required={false}
                  placeHolder={t('ENTER_ACCOUNTING_CODE')}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <Dropdown.BakeasySelectLanguage
                  disabled={isView}
                  value={selectedLanguage}
                  required={false}
                  onChange={(e: any) => {
                    setSelectedLanguage(e.target.value);
                  }}
                  placeholder={t('SELECT_LANGUAGE')}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <Dropdown.Category
                  //disabled={true}
                  options={SUPPLIER_CATEGORY_ARRAY}
                  value={selectedCategory}
                  required={true}
                  onChange={(event: any) => {
                    setSelectedCategory(event?.target?.value);
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <TextField.Name
                  disabled={isView}
                  label={t('SUPPLIER_NAME')}
                  helperMessage={t('PLEASE_ENTER_VALID_SUPPLIER_NAME')}
                  value={supplierName}
                  onChange={(event: any) => {
                    setSupplierName(event?.target?.value);
                  }}
                  placeHolder={t('ENTER_SUPPLIER_NAME')}
                  required={true}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <TextField.Username
                  disabled={isEdit || isView}
                  value={userName}
                  onChange={(event: any) => {
                    setUserName(event.target.value);
                  }}
                  placeHolder={t('ENTER_USER_NAME')}
                />
              </Grid>

              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <TextField.Password
                  value={password}
                  // required={true}
                  required={!isEdit}
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    setPassword(event.target.value);
                  }}
                  placeHolder={t('ENTER_PASSWORD')}
                />
              </Grid>

              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <Dropdown.YesNo
                  disabled={isView}
                  label={t('DIFFERENT_LEGAL_NAME')}
                  value={differentLegalName}
                  onChange={(event: any) => {
                    setDifferentLegalName(event?.target?.value);
                    setLegalName('');
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <TextField.LegalName
                  disabled={
                    differentLegalName === 'Yes' || differentLegalName === 'Oui'
                      ? false
                      : true
                  }
                  label={t('LEGAL_NAME')}
                  value={
                    differentLegalName === 'Yes' || differentLegalName === 'Oui'
                      ? legalName
                      : supplierName
                  }
                  maxLength={100}
                  onChange={
                    differentLegalName === 'Yes' || differentLegalName === 'Oui'
                      ? (event: any) => setLegalName(event?.target?.value)
                      : undefined
                  }
                  required={true}
                  placeHolder={t('ENTER_LEGAL_NAME')}
                />
              </Grid>

              {/* <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <TextField.State
                disabled={isView}
                label={t('SUPPLIER_STATE')}
                value={supplierState}
                onChange={(event: any) => {
                  setSupplierState(event.target.value);
                }}
              />
            </Grid> */}

              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                {/* <TextField.Country
                disabled={isView}
                label={t('SUPPLIER_COUNTRY')}
                value={supplierCountry}
                onChange={(event: any) => {
                  setSupplierCountry(event.target.value);
                }}
              /> */}
                <BakeasyAutoCompleteCountry
                  label={'SUPPLIER_COUNTRY'}
                  placeholder={t('SELECT_COUNTRY')}
                  value={supplierCountry}
                  options={_countryState.value?.data}
                  required={true}
                  onChange={(newValue: any) => {
                    // if (typeof newValue === 'string' && newValue?.length === 0) {
                    //   dispatch(fetchCountries({ page: 1, limit: 5 }));
                    // }

                    // if (typeof newValue === 'string' && newValue?.length > 2) {
                    //   dispatch(fetchCountries({ page: 1, limit: 5, search: newValue }));
                    // }

                    if (typeof newValue === 'object') {
                      handleSupplierCountrySelect(newValue);
                      setSupplierPostCode('');
                    }

                    if (newValue === null) {
                      setSupplierCountry(null);
                      setSupplierPostCode('');
                      //dispatch(fetchCountries({ page: 1, limit: 5 }));
                    }
                  }}
                />
              </Grid>

              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyAutoCompleteState
                  // label="SUPPLIER_STATE"
                  // label={
                  //   supplierCountry?.countryName === 'Canada' ? 'SUPPLIER_PROVINCE' : 'SUPPLIER_STATE'
                  // }
                  label={'SUPPLIER_STATE_PROVINCE'}
                  placeholder={t('SELECT_SUPPLIER_STATE_PROVINCE')}
                  disabled={supplierCountry === null}
                  required={true}
                  value={supplierState}
                  options={_statesState.value?.data}
                  onChange={async (newValue: any) => {
                    // if (typeof newValue === 'string' && newValue?.length > 2) {
                    //   if (
                    //     _statesState.value?.data?.find(
                    //       (item: any) => item?.stateName === newValue
                    //     ) === undefined
                    //   ) {
                    //     if (supplierCountry !== undefined && supplierCountry !== null) {
                    //       dispatch(
                    //         fetchStates({
                    //           page: 1,
                    //           limit: 10,
                    //           countryId: supplierCountry?._id,
                    //           search: newValue
                    //         })
                    //       );
                    //     }
                    //   }
                    // }

                    // if (
                    //   typeof newValue === 'string' &&
                    //   newValue?.length === 0 &&
                    //   supplierCountry !== null
                    // ) {
                    //   await dispatch(
                    //     fetchStates({ page: 1, limit: 10, countryId: supplierCountry?._id })
                    //   );
                    // }

                    // if (typeof newValue === 'string' && newValue?.length === 0) {
                    //   if (supplierCountry) {
                    //     let payload: any = { page: 1, limit: 5, categoryId: supplierCountry?._id };
                    //     //await dispatch(fetchStates(payload));
                    //   }
                    // }

                    // if (typeof newValue === 'string' && newValue?.length > 2) {
                    //   if (supplierCountry) {
                    //     let payload: any = {
                    //       page: 1,
                    //       limit: 5,
                    //       categoryId: supplierCountry?._id,
                    //       search: newValue
                    //     };
                    //     //await dispatch(fetchStates(payload));
                    //   }
                    // }

                    if (typeof newValue === 'object') {
                      setSupplierState(newValue);
                    }
                    if (newValue === null) {
                      setSupplierState(null);
                    }
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <TextField.City
                  disabled={isView}
                  label={t('SUPPLIER_CITY')}
                  value={supplierCity}
                  onChange={(event: any) => {
                    setSupplierCity(event.target.value);
                  }}
                  required={true}
                  placeHolder={t('ENTER_SUPPLIER_CITY')}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <TextField.Address
                  disabled={isView}
                  label={t('SUPPLIER_ADDRESS')}
                  placeHolder={t('ENTER_SUPPLIER_ADDRESS')}
                  value={supplierAddress}
                  onChange={(event: any) => {
                    setSupplierAddress(event.target.value);
                  }}
                  required={true}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                {/* <TextField.Pincode
                disabled={isView}
                label={t('SUPPLIER_POSTAL_CODE')}
                value={supplierPostCode}
                required={true}
                onChange={(event: any) => {
                  setSupplierPostCode(preparePostalCode(event.target.value));
                }}
              /> */}
                <TextField.Pincode
                  disabled={isView}
                  label={t('SUPPLIER_POSTAL_CODE')}
                  placeHolder={t('ENTER_SUPPLIER_POSTAL_CODE')}
                  helperMessage={t('PLEASE_ENTER_VALID_SUPPLIER_POSTAL_CODE')}
                  value={supplierPostCode}
                  required={true}
                  maxLength={getMaxLengthForPostalCode(
                    supplierCountry?.countryName
                  )}
                  regexPattern={getRegexPatternForPostalCode(
                    supplierCountry?.countryName
                  )}
                  onChange={(event: any) => {
                    setSupplierPostCode(
                      preparePostalCode(
                        event.target.value,
                        supplierCountry?.countryName
                      )
                    );
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <TextField.EmailId
                  disabled={isView}
                  required={true}
                  label={t('SUPPLIER_EMAIL')}
                  placeHolder={t('ENTER_SUPPLIER_EMAIL_ID')}
                  value={supplierEmail}
                  onChange={(event: any) => {
                    setSupplierEmail(event.target.value);
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <TextField.Work
                  label={t('SUPPLIER_WORK')}
                  disabled={isView}
                  required={true}
                  value={supplierWork}
                  onChange={(event: any) => {
                    setSupplierWork(prepareMobileNumber(event?.target?.value));
                  }}
                  placeHolder={t('ENTER_SUPPLIER_WORK')}
                />
              </Grid>

              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <TextField.Tax1
                  disabled={isView}
                  value={adminTax1}
                  placeHolder={t('ENTER_ADMIN_TAX_1')}
                  onChange={(event: any) => {
                    setAdminTax1(event.target.value);
                  }}
                />
              </Grid>

              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <TextField.Tax2
                  disabled={isView}
                  placeHolder={t('ENTER_ADMIN_TAX_2')}
                  value={adminTax2}
                  onChange={(event: any) => {
                    setAdminTax2(event.target.value);
                  }}
                />
              </Grid>
            </Grid>

            <BakeasyDivider />

            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <BakeasyHeaderLabel message={t('CONTACT1')} />
              </Grid>
              <Grid container spacing={2} ml={2}>
                <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                  <TextField.FirstName
                    disabled={isView}
                    value={contactOneFirstName}
                    onChange={(event: any) => {
                      setContactOneFirstName(event.target.value);
                    }}
                    required={true}
                    placeHolder={t('ENTER_FIRST_NAME')}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                  <TextField.LastName
                    disabled={isView}
                    value={contactOneLastName}
                    onChange={(event: any) => {
                      setContactOneLastName(event.target.value);
                    }}
                    required={true}
                    placeHolder={t('ENTER_LAST_NAME')}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                  <TextField.EmailId
                    disabled={isView}
                    value={contactOneEmail}
                    onChange={(event: any) => {
                      setContactOneEmail(event.target.value);
                    }}
                    required={true}
                    placeHolder={t('ENTER_EMAIL_ID')}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                  <TextField.Work
                    disabled={isView}
                    value={contactOneWork}
                    onChange={(event: any) => {
                      setContactOneWork(
                        prepareMobileNumber(event.target.value)
                      );
                    }}
                    required={true}
                    placeHolder={t('ENTER_WORK')}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                  <TextField.Mobile
                    disabled={isView}
                    value={contactOneMobile}
                    onChange={(event: any) => {
                      setContactOneMobile(
                        prepareMobileNumber(event.target.value)
                      );
                    }}
                    required={false}
                    placeHolder={t('ENTER_MOBILE_NUMBER')}
                  />
                </Grid>
              </Grid>
            </Grid>

            <BakeasyDivider />

            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <BakeasyHeaderLabel message={t('CONTACT2')} />
              </Grid>
              <Grid container spacing={2} ml={2}>
                <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                  <TextField.FirstName
                    disabled={isView}
                    required={false}
                    value={contactTwoFirstName}
                    onChange={(event: any) => {
                      setContactTwoFirstName(event.target.value);
                    }}
                    placeHolder={t('ENTER_FIRST_NAME')}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                  <TextField.LastName
                    disabled={isView}
                    required={false}
                    value={contactTwoLastName}
                    onChange={(event: any) => {
                      setContactTwoLastName(event.target.value);
                    }}
                    placeHolder={t('ENTER_LAST_NAME')}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                  <TextField.EmailId
                    disabled={isView}
                    required={false}
                    value={contactTwoEmail}
                    onChange={(event: any) => {
                      setContactTwoEmail(event.target.value);
                    }}
                    placeHolder={t('ENTER_EMAIL_ID')}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                  <TextField.Work
                    disabled={isView}
                    required={false}
                    value={contactTwoWork}
                    onChange={(event: any) => {
                      setContactTwoWork(
                        prepareMobileNumber(event.target.value)
                      );
                    }}
                    placeHolder={t('ENTER_WORK')}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                  <TextField.Mobile
                    disabled={isView}
                    required={false}
                    value={contactTwoMobile}
                    onChange={(event: any) => {
                      setContactTwoMobile(
                        prepareMobileNumber(event.target.value)
                      );
                    }}
                    placeHolder={t('ENTER_MOBILE_NUMBER')}
                  />
                </Grid>
              </Grid>
            </Grid>

            <BakeasyDivider />

            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <BakeasyHeaderLabel message={t('CONTACT_ACCOUNTING')} />
              </Grid>
              <Grid container spacing={2} ml={2}>
                <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                  <TextField.FirstName
                    disabled={isView}
                    value={accountingFirstName}
                    onChange={(event: any) => {
                      setAccountingFirstName(event.target.value);
                    }}
                    required={false}
                    placeHolder={t('ENTER_FIRST_NAME')}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                  <TextField.LastName
                    disabled={isView}
                    value={accountingLastName}
                    onChange={(event: any) => {
                      setAccountingLastName(event.target.value);
                    }}
                    required={false}
                    placeHolder={t('ENTER_LAST_NAME')}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                  <TextField.EmailId
                    disabled={isView}
                    value={accountingEmail}
                    onChange={(event: any) => {
                      setAccountingEmail(event.target.value);
                    }}
                    required={false}
                    placeHolder={t('ENTER_EMAIL_ID')}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                  <TextField.Work
                    disabled={isView}
                    value={accountingWork}
                    onChange={(event: any) => {
                      setAccountingWork(
                        prepareMobileNumber(event.target.value)
                      );
                    }}
                    required={false}
                    placeHolder={t('ENTER_WORK')}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                  <TextField.Mobile
                    disabled={isView}
                    value={accountingMobile}
                    onChange={(event: any) => {
                      setAccountingMobile(
                        prepareMobileNumber(event.target.value)
                      );
                    }}
                    required={false}
                    placeHolder={t('ENTER_MOBILE_NUMBER')}
                  />
                </Grid>
              </Grid>
            </Grid>

            <BakeasyDivider />

            <Grid container spacing={2}>
              <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
                <BakeasyHeaderLabel message={t('CHAIN_STORE_PARENT')} />
              </Grid>
              <Grid item xs={12} sm={6} md={6} lg={3} xl={3}>
                <BakeasySwitch
                  label={'No / Yes'}
                  disabled={isView}
                  value={isChainStore}
                  onChange={(event: any) => {
                    event.stopPropagation();
                    setIsChainStore(event?.target?.checked);
                    handleChainStoreCheck(event?.target?.checked);
                  }}
                />
              </Grid>
              {isChainStore && (
                <Grid container ml={2} spacing={2}>
                  <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                    <TextField.Name
                      disabled={isView}
                      label={t('CHAIN_STORE_NAME')}
                      value={chainStoreName}
                      onChange={(event: any) => {
                        setChainStoreName(event.target.value);
                      }}
                      required={true}
                      placeHolder={t('ENTER_CHAIN_STORE_NAME')}
                    />
                  </Grid>

                  <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                    {/* <TextField.Country
                    disabled={isView}
                    label={t('PARENT_COUNTRY')}
                    value={parentCountry}
                    onChange={(event: any) => {
                      setParentCountry(event.target.value);
                    }}
                  /> */}
                    <BakeasyAutoCompleteCountry
                      label={'PARENT_COUNTRY'}
                      placeholder={t('SELECT_PARENT_COUNTRY')}
                      value={parentCountry}
                      options={_countryState.value?.data}
                      required={true}
                      onChange={(newValue: any) => {
                        // if (typeof newValue === 'string' && newValue?.length === 0) {
                        //   dispatch(fetchCountries({ page: 1, limit: 5 }));
                        // }

                        // if (typeof newValue === 'string' && newValue?.length > 2) {
                        //   dispatch(fetchCountries({ page: 1, limit: 5, search: newValue }));
                        // }

                        if (typeof newValue === 'object') {
                          handleParentCountrySelect(newValue);
                          setParentPostCode('');
                        }

                        if (newValue === null) {
                          setParentCountry(null);
                          setParentPostCode('');
                          //dispatch(fetchCountries({ page: 1, limit: 5 }));
                        }
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                    {/* <TextField.State
                    disabled={isView}
                    label={t('PARENT_STATE')}
                    value={parentState}
                    onChange={(event: any) => {
                      setParentState(event.target.value);
                    }}
                  /> */}
                    <BakeasyAutoCompleteState
                      label={'PARENT_STATE'}
                      // label={parentCountry?.countryName === 'Canada' ? 'PROVINCE' : 'PARENT_STATE'}
                      disabled={parentCountry === null}
                      placeholder={t('SELECT_PARENT_STATE')}
                      required={true}
                      value={parentState}
                      options={_statesState.value?.data}
                      onChange={async (newValue: any) => {
                        if (typeof newValue === 'object') {
                          setParentState(newValue);
                        }
                        if (newValue === null) {
                          setParentState(null);
                        }
                      }}
                    />
                  </Grid>

                  <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                    <TextField.City
                      disabled={isView}
                      label={t('PARENT_CITY')}
                      value={parentCity}
                      onChange={(event: any) => {
                        setParentCity(event.target.value);
                      }}
                      required={true}
                      placeHolder={t('ENTER_PARENT_CITY')}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                    <TextField.Address
                      disabled={isView}
                      label={t('PARENT_ADDRESS')}
                      value={parentAddress}
                      onChange={(event: any) => {
                        setParentAddress(event.target.value);
                      }}
                      placeHolder={t('ENTER_PARENT_ADDRESS')}
                      required={true}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                    <TextField.Pincode
                      disabled={isView}
                      label={t('PARENT_POSTAL_CODE')}
                      value={parentPostCode}
                      required={true}
                      helperMessage={t('PLEASE_ENTER_VALID_PARENT_POSTAL_CODE')}
                      placeHolder={t('ENTER_PARENT_POSTAL_CODE')}
                      maxLength={getMaxLengthForPostalCode(
                        parentCountry?.countryName
                      )}
                      regexPattern={getRegexPatternForPostalCode(
                        parentCountry?.countryName
                      )}
                      onChange={(event: any) => {
                        setParentPostCode(
                          preparePostalCode(
                            event.target.value,
                            parentCountry?.countryName
                          )
                        );
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                    <TextField.EmailId
                      disabled={isView}
                      label={t('PARENT_EMAIL_ID')}
                      value={parentEmailId}
                      onChange={(event: any) => {
                        setParentEmailId(event.target.value);
                      }}
                      required={true}
                      placeHolder={t('ENTER_PARENT_EMAIL_ID')}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                    <TextField.Work
                      disabled={isView}
                      label={t('PARENT_WORK_NUMBER')}
                      value={parentWork}
                      onChange={(event: any) => {
                        setParentWork(prepareMobileNumber(event.target.value));
                      }}
                      required={true}
                      placeHolder={t('ENTER_PARENT_WORK_NUMBER')}
                    />
                  </Grid>
                </Grid>
              )}
            </Grid>

            <BakeasyDivider />

            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <BakeasyHeaderLabel message={t('BILLING_DETAILS')} />
              </Grid>
              <Grid container spacing={2} ml={2}>
                <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                  <Dropdown.BillTo
                    disabled={isView}
                    placeholder={t('SELECT_BILL_TO')}
                    options={
                      isChainStore
                        ? BILL_TO_ARRAY
                        : BILL_TO_ARRAY_WITHOUT_CHAINSTORE
                    }
                    value={selectedBillTo}
                    required={true}
                    onChange={(event: any) => {
                      setSelectedBillTo(event.target.value);
                      setBillToData(event?.target?.value);
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                  <TextField.Name
                    label={t('BILL_TO_NAME')}
                    disabled={isView}
                    value={billToName}
                    required={true}
                    onChange={(event: any) => {
                      setBillToName(event.target.value);
                    }}
                    placeHolder={t('ENTER_NAME')}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                  <TextField.CompanyName
                    disabled={isView}
                    label={t('COMPANY_NAME')}
                    value={billToCompanyName}
                    required={true}
                    onChange={(event: any) => {
                      setBillToCompanyName(event.target.value);
                    }}
                    placeHolder={t('ENTER_COMPANY_NAME')}
                  />
                </Grid>

                <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                  {/* <TextField.Country
                  disabled={isView}
                  value={billToCountry}
                  onChange={(event: any) => {
                    setBillToCountry(event.target.value);
                  }}
                /> */}
                  <BakeasyAutoCompleteCountry
                    label={'BILL_TO_COUNTRY'}
                    value={billToCountry}
                    placeholder={t('SELECT_BILL_TO_COUNTRY')}
                    required={true}
                    options={_countryState.value?.data}
                    onChange={(newValue: any) => {
                      // if (typeof newValue === 'string' && newValue?.length === 0) {
                      //   dispatch(fetchCountries({ page: 1, limit: 5 }));
                      // }

                      // if (typeof newValue === 'string' && newValue?.length > 2) {
                      //   dispatch(fetchCountries({ page: 1, limit: 5, search: newValue }));
                      // }

                      if (typeof newValue === 'object') {
                        handleBillToCountrySelect(newValue);
                        setBillToPostCode('');
                      }

                      if (newValue === null) {
                        setBillToCountry(null);
                        setBillToPostCode('');
                        //dispatch(fetchCountries({ page: 1, limit: 5 }));
                      }
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                  {/* <TextField.State
                  disabled={isView}
                  value={billToState}
                  onChange={(event: any) => {
                    setBillToState(event.target.value);
                  }}
                /> */}
                  <BakeasyAutoCompleteState
                    label={'STATE'}
                    // label={billToCountry?.countryName === 'Canada' ? 'PROVINCE' : 'STATE'}
                    disabled={billToCountry === null}
                    placeholder={t('SELECT_STATE_PROVINCE')}
                    value={billToState}
                    options={_statesState.value?.data}
                    required={true}
                    onChange={async (newValue: any) => {
                      if (typeof newValue === 'object') {
                        setBillToState(newValue);
                      }
                      if (newValue === null) {
                        setBillToState(null);
                      }
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                  <TextField.City
                    disabled={isView}
                    placeholder={t('ENTER_CITY')}
                    value={billToCity}
                    onChange={(event: any) => {
                      setBillToCity(event.target.value);
                    }}
                    required={true}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                  <TextField.Address
                    disabled={isView}
                    label={t('COMPANY_ADDRESS')}
                    value={billToAddress}
                    required={true}
                    onChange={(event: any) => {
                      setBillToAddress(event.target.value);
                    }}
                    placeHolder={t('ENTER_COMPANY_ADDRESS')}
                  />
                </Grid>

                <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                  <TextField.Pincode
                    // disabled={isView}
                    // value={billToPostCode}
                    // required={true}
                    // onChange={(event: any) => {
                    //   setBillToPostCode(preparePostalCode(event.target.value));
                    // }}
                    disabled={isView}
                    value={billToPostCode}
                    placeHolder={t('ENTER_POSTAL_CODE')}
                    required={true}
                    maxLength={getMaxLengthForPostalCode(
                      billToCountry?.countryName
                    )}
                    regexPattern={getRegexPatternForPostalCode(
                      billToCountry?.countryName
                    )}
                    onChange={(event: any) => {
                      setBillToPostCode(
                        preparePostalCode(
                          event.target.value,
                          billToCountry?.countryName
                        )
                      );
                    }}
                  />
                </Grid>
              </Grid>
            </Grid>

            <BakeasyDivider />

            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                  <BakeasyHeaderLabel message={t('PAYMENT')} />
                </Grid>

                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                  <Grid container spacing={2} pl={2}>
                    <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                      <BakeasyAutoCompletePaymentMethod
                        label={t('METHOD')}
                        placeholder={t('SELECT_PAYMENT_METHOD')}
                        required={true}
                        value={selectedPaymentMethod}
                        options={_dropdownDataState.value?.data?.PaymentMethod}
                        onChange={async (newValue: any) => {
                          if (typeof newValue === 'object') {
                            setSelectedPaymentMethod(newValue);
                          }
                          if (newValue === null) {
                            setSelectedPaymentMethod(null);
                          }
                        }}
                      />
                      {/* <Dropdown.PaymentMethod
                      disabled={isView}
                      value={selectedPaymentMethod}
                      required={true}
                      onChange={(event: any) => {
                        setSelectedPaymentMethod(event.target.value);
                      }}
                    /> */}
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                      {/* <Dropdown.PaymentTerms
                      disabled={isView}
                      value={selectedPaymentTerm}
                      required={true}
                      onChange={(event: any) => {
                        setSelectedPaymentTerm(event.target.value);
                      }}
                    /> */}
                      <BakeasyAutoCompletePaymentTerms
                        label={t('TERMS')}
                        required={true}
                        value={selectedPaymentTerm}
                        placeholder={t('SELECT_TERMS')}
                        options={_dropdownDataState.value?.data?.PaymentTerms}
                        onChange={async (newValue: any) => {
                          if (typeof newValue === 'object') {
                            setSelectedPaymentTerm(newValue);
                          }
                          if (newValue === null) {
                            setSelectedPaymentTerm(null);
                          }
                        }}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                  <BakeasyHeaderLabel message={t('BILLING')} />
                </Grid>

                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                  <Grid container spacing={2} pl={2}>
                    <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                      {/* <Dropdown.SetupFee
                      disabled={isView}
                      value={selectedBillingSetupFee}
                      required={true}
                      onChange={(event: any) => {
                        setSelectedBillingSetupFee(event.target.value);
                      }}
                    /> */}
                      <BakeasyAutoCompleteSetupFee
                        label={t('SETUP_FEE')}
                        placeholder={t('SELECT_SETUP_FEE')}
                        required={true}
                        value={selectedBillingSetupFee}
                        options={_dropdownDataState.value?.data?.SetupFee}
                        onChange={async (newValue: any) => {
                          if (typeof newValue === 'object') {
                            setSelectedBillingSetupFee(newValue);
                          }
                          if (newValue === null) {
                            setSelectedBillingSetupFee(null);
                          }
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                      {/* <Dropdown.SubscriptionPack
                      disabled={isView}
                      value={selectedBillingSubscriptionPack}
                      required={true}
                      onChange={(event: any) => {
                        setSelectedBillingSubscriptionPack(event.target.value);
                      }}
                    /> */}
                      <BakeasyAutoCompleteSubscriptionPack
                        label={t('SUBSCRIPTION_PACK')}
                        placeholder={t('SELECT_SUBSCRIPTION_PACK')}
                        required={true}
                        value={selectedBillingSubscriptionPack}
                        options={
                          _dropdownDataState.value?.data?.SubscriptionPack
                        }
                        onChange={async (newValue: any) => {
                          if (typeof newValue === 'object') {
                            setSelectedBillingSubscriptionPack(newValue);
                          }
                          if (newValue === null) {
                            setSelectedBillingSubscriptionPack(null);
                          }
                        }}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>

            <BakeasyDivider />

            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                  <BakeasyHeaderLabel message={t('TAXES')} />
                </Grid>

                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                  <Grid container spacing={2} pl={2}>
                    <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                      {/* <Dropdown.TaxRateOne
                      disabled={isView}
                      required={true}
                      value={selectedtaxrateOne}
                      onChange={(event: any) => {
                        setSelectedtaxrateOne(event.target.value);
                      }}
                    /> */}
                      <BakeasyAutoCompleteTax
                        key={'1'}
                        label={'SUPPLIER_TAX1'}
                        value={selectedtaxrateOne}
                        placeholder={t('SELECT_SUPPLIER_TAX1')}
                        options={
                          _taxesState.value?.data?.length > 0
                            ? _taxesState.value?.data
                            : null
                        }
                        required={true}
                        onAddClick={(props: any) => {
                          openAddTaxDialog(props);
                        }}
                        onChange={async (newValue: any) => {
                          if (
                            typeof newValue === 'string' &&
                            newValue?.length > 2
                          ) {
                            if (
                              _taxesState.value?.data?.find(
                                (item: any) => item?.taxName === newValue
                              ) === undefined
                            ) {
                              if (
                                supplierCountry !== undefined &&
                                supplierCountry !== 'Not Applicable' &&
                                supplierCountry !== null
                              ) {
                                dispatch(
                                  fetchTaxes({
                                    page: 1,
                                    limit: 10,
                                    countryId: supplierCountry?._id,
                                    search: newValue,
                                  })
                                );
                              }
                            }
                          }

                          if (
                            typeof newValue === 'string' &&
                            newValue?.length === 0 &&
                            supplierCountry !== null
                          ) {
                            await dispatch(
                              fetchTaxes({
                                page: 1,
                                limit: 10,
                                countryId: supplierCountry?._id,
                              })
                            );
                          }

                          if (
                            typeof newValue === 'object' &&
                            newValue?.id !== 0
                          ) {
                            setSelectedtaxrateOne(newValue);
                          }
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                      {/* <Dropdown.TaxRateTwo
                      disabled={isView}
                      required={true}
                      value={selectedtaxrateTwo}
                      onChange={(event: any) => {
                        setSelectedtaxrateTwo(event.target.value);
                      }}
                    /> */}
                      <BakeasyAutoCompleteTax
                        key={'2'}
                        label="SUPPLIER_TAX2"
                        placeholder={t('SELECT_SUPPLIER_TAX2')}
                        value={selectedtaxrateTwo}
                        options={
                          _taxesState.value?.data?.length > 0
                            ? _taxesState.value?.data
                            : null
                        }
                        required={true}
                        onAddClick={(props: any) => {
                          openAddTaxDialog(props);
                        }}
                        onChange={(newValue: any) => {
                          if (
                            typeof newValue === 'string' &&
                            newValue?.length > 2
                          ) {
                            if (
                              _taxesState.value?.data?.find(
                                (item: any) => item?.taxName === newValue
                              ) === undefined
                            ) {
                              if (
                                supplierCountry !== undefined &&
                                supplierCountry?.countryName !==
                                  'Not Applicable' &&
                                supplierCountry !== null
                              ) {
                                dispatch(
                                  fetchTaxes({
                                    page: 1,
                                    limit: 10,
                                    countryId: supplierCountry?._id,
                                    search: newValue,
                                  })
                                );
                              }
                            }
                          }

                          if (
                            typeof newValue === 'string' &&
                            newValue?.length === 0 &&
                            supplierCountry !== null
                          ) {
                            dispatch(
                              fetchTaxes({
                                page: 1,
                                limit: 10,
                                countryId: supplierCountry?._id,
                              })
                            );
                          }

                          if (
                            typeof newValue === 'object' &&
                            newValue?.id !== 0
                          ) {
                            setSelectedtaxrateTwo(newValue);
                          }
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                      <TextField.Name
                        disabled={true}
                        required={true}
                        placeHolder={t('ENTER_SUPPLIER_TAX1_RATE')}
                        helperMessage={t('PLEASE_ENTER_SUPPLIER_TAX1')}
                        label={t('SUPPLIER_TAX1_RATE')}
                        value={
                          selectedtaxrateOne?.taxName
                            ? selectedtaxrateOne?.taxName
                                ?.split(' - ', 10)
                                .pop()
                            : ''
                        }
                      />
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                      <TextField.Name
                        disabled={true}
                        required={true}
                        placeHolder={t('ENTER_SUPPLIER_TAX2_RATE')}
                        helperMessage={t('PLEASE_ENTER_SUPPLIER_TAX2')}
                        label={t('SUPPLIER_TAX2_RATE')}
                        value={
                          selectedtaxrateTwo?.taxName
                            ? selectedtaxrateTwo?.taxName
                                ?.split(' - ', 10)
                                .pop()
                            : ''
                        }
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                  <BakeasyHeaderLabel message={t('STATUS')} />
                </Grid>

                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                  <Grid container spacing={2} pl={2}>
                    <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                      <Dropdown.Status
                        disabled={isView}
                        required={true}
                        options={STATUS_ARRAY}
                        value={selectedStatus}
                        onChange={(event: any) => {
                          setSelectedStatus(event.target.value);
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                      <BakeasyCheckbox
                        disabled={isView}
                        required={true}
                        label={t('RECIPE_BUILDER')}
                        value={recipeBuilder}
                        onClick={(event: any) => {
                          setRecipeBuilder(event?.target?.checked);
                        }}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>

            <BakeasyDivider />
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <BakeasyHeaderLabel message={t('OTHER_DETAILS')} />
              </Grid>

              <Grid container spacing={2} ml={2}>
                <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                  <TextField.Description
                    disabled={isView}
                    label={t('DESCRIPTION')}
                    type="text"
                    placeHolder={t('ENTER_DESCRIPTION')}
                    name="description"
                    multiline
                    rows={6}
                    value={description}
                    required={false}
                    onChange={(event: any) => {
                      setDescription(event.target.value);
                    }}
                  />
                </Grid>

                {/* conditions for new */}
                {!isEdit && !isView && location?.state.isNew && (
                  <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                    <BakeasyImgSelector
                      uploadState={'initial'}
                      id="supplierLogo"
                      value={selectedSupplierLogoFile}
                      label={t('SUPPLIER_LOGO')}
                      name="supplier-logo"
                      headerText={t('ACCEPTED_FORMATS')}
                      footerText={t('PLEASE_UPLOAD')}
                      onChange={(file: any) => {
                        setSelectedSupplierLogoFile(file);
                      }}
                    />
                  </Grid>
                )}

                {/* conditions if not logo present through edit and view */}
                {(!isEdit && !isView) ||
                  (isEdit && !supplierData?.supplierLogo && (
                    <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                      <BakeasyImgSelector
                        uploadState={'initial'}
                        id="supplierLogo"
                        value={selectedSupplierLogoFile}
                        label={t('SUPPLIER_LOGO')}
                        name="supplier-logo"
                        headerText={t('ACCEPTED_FORMATS')}
                        footerText={t('PLEASE_UPLOAD')}
                        onChange={(file: any) => {
                          setSelectedSupplierLogoFile(file);
                        }}
                      />
                    </Grid>
                  ))}

                {/* conditions if logo present */}
                {(isEdit || isView) && supplierData?.supplierLogo && (
                  <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                    <BakeasyImgSelector
                      disabled={isView}
                      uploadState={'initFromProps'}
                      id="supplierLogo"
                      value={supplierData?.supplierLogo}
                      label={t('SUPPLIER_LOGO')}
                      name="supplier-logo"
                      headerText={t('ACCEPTED_FORMATS')}
                      footerText={t('PLEASE_UPLOAD')}
                      onChange={(file: any) => {
                        setSelectedSupplierLogoFile(file);
                      }}
                      onClick={() =>
                        openImageDialog(
                          'ViewImage',
                          t('SUPPLIER_LOGO'),
                          supplierData?.supplierLogo
                        )
                      }
                    />
                  </Grid>
                )}
              </Grid>
            </Grid>

            {!isView && (
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={12}
                xl={12}
                sx={{ display: 'flex', justifyContent: 'space-between' }}
              >
                <Grid
                  container
                  sx={{ alignItems: 'end', justifyContent: 'end' }}
                >
                  <Grid margin={1}>
                    <Button.Cancel
                      variant="outlined"
                      onClick={(event: React.MouseEvent<HTMLButtonElement>) => {
                        openConfirmDialogMesssageValidation();
                      }}
                    />
                  </Grid>

                  <Grid margin={1}>
                    {isEdit ? (
                      <Button.Update
                        onClick={(
                          event: React.MouseEvent<HTMLButtonElement>
                        ) => {
                          onSubmit();
                        }}
                      />
                    ) : (
                      <Button.Create
                        onClick={(
                          event: React.MouseEvent<HTMLButtonElement>
                        ) => {
                          onSubmit();
                        }}
                      />
                    )}
                  </Grid>
                </Grid>
              </Grid>
            )}
          </BakeasyPaper>
        </Grid>
      </div>
    );
  }

  function ViewSupplierUI() {
    return (
      <Grid>
        <Grid item sx={{ marginBottom: 1 }}>
          <BakeasyAppBar
            title={t('SUPPLIER_DETAILS')}
            onBackClick={() => {
              navigate(-1);
            }}
            menus={getMenus()}
          />
        </Grid>

        <BakeasyPaper>
          <Grid
            sx={{
              display: 'flex',
              marginLeft: '1',
              justifyContent: 'space-between',
            }}
          >
            <Grid container>
              <BakeasyHeaderLabel message={t('SUPPLIER_DETAILS')} />
            </Grid>

            {/* {isEdit && (
							<Grid
								container
								sx={{ alignItems: "center", justifyContent: "end" }}
							>
								<BakeasyChipDeactive onClick={() => {}} />
								<BakeasyChipDelete onClick={() => {}} />
							</Grid>
						)} */}
          </Grid>

          <Grid container spacing={2} pl={2}>
            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <BakeasyLabelText
                label={t('DATE_REGISTERED')}
                value={
                  registrationDate
                    ? dayjs(registrationDate).format('MM/DD/YYYY')
                    : dayjs(new Date()).format('MM/DD/YYYY')
                }
              />
              {/* <BakeasyDatePicker
								label={t("DATE_REGISTERED")}
								value={registrationDate ? registrationDate : dayjs(new Date())}
								disabled={true}
							/> */}
            </Grid>

            {(isEdit || isView) && (
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyLabelText label={t('SUPPLIER_ID')} value={supplierID} />
              </Grid>
            )}

            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <BakeasyLabelText
                label={t('ACCOUNTING_CODE')}
                value={accountingCode}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <BakeasyLabelText
                label={t('LANGUAGE')}
                value={selectedLanguage}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <BakeasyLabelText
                label={t('CATEGORY')}
                value={
                  //selectedCategory
                  selectedCategory
                    ? t(
                        `${selectedCategory?.toUpperCase().replace(/\s+/g, '_')}`
                      )
                    : selectedCategory
                }
              />
            </Grid>
            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <BakeasyLabelText
                label={t('SUPPLIER_NAME')}
                value={supplierName}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <BakeasyLabelText label={t('USERNAME')} value={userName} />
            </Grid>

            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <BakeasyLabelText label={t('LEGAL_NAME')} value={legalName} />
            </Grid>

            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <BakeasyLabelText
                label={t('SUPPLIER_COUNTRY')}
                value={
                  supplierCountry?.countryName
                    ? t(
                        `${supplierCountry.countryName.toUpperCase().replace(/\s+/g, '_')}`
                      )
                    : supplierCountry
                }
              />
            </Grid>
            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <BakeasyLabelText
                // label={t('SUPPLIER_STATE')}
                // label={
                //   supplierCountry?.countryName === 'Canada' ? 'SUPPLIER_PROVINCE' : 'SUPPLIER_STATE'
                // }
                label={t('SUPPLIER_STATE_PROVINCE')}
                value={
                  supplierState?.stateName
                    ? t(
                        `${supplierState.stateName.toUpperCase().replace(/\s+/g, '_')}`
                      )
                    : supplierState
                }
              />
            </Grid>
            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <BakeasyLabelText
                label={t('SUPPLIER_CITY')}
                value={supplierCity}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <BakeasyLabelText
                label={t('SUPPLIER_ADDRESS')}
                value={supplierAddress}
              />
            </Grid>

            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <BakeasyLabelText
                label={t('SUPPLIER_POSTAL_CODE')}
                value={supplierPostCode}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <BakeasyLabelText label={t('EMAIL_ID')} value={supplierEmail} />
            </Grid>
            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <BakeasyLabelText label={t('WORK')} value={supplierWork} />
            </Grid>

            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <BakeasyLabelText label={t('ADMIN_TAX1')} value={adminTax1} />
            </Grid>

            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <BakeasyLabelText label={t('ADMIN_TAX1')} value={adminTax2} />
            </Grid>
          </Grid>

          <BakeasyDivider />

          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <BakeasyHeaderLabel message={t('CONTACT1')} />
            </Grid>
            <Grid container spacing={2} ml={2}>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyLabelText
                  label={t('FIRST_NAME')}
                  value={contactOneFirstName}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyLabelText
                  label={t('LAST_NAME')}
                  value={contactOneLastName}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyLabelText
                  label={t('EMAIL_ID')}
                  value={contactOneEmail}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyLabelText label={t('WORK')} value={contactOneWork} />
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyLabelText
                  label={t('MOBILE')}
                  value={contactOneMobile}
                />
              </Grid>
            </Grid>
          </Grid>

          <BakeasyDivider />

          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <BakeasyHeaderLabel message={t('CONTACT2')} />
            </Grid>
            <Grid container spacing={2} ml={2}>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyLabelText
                  label={t('FIRST_NAME')}
                  value={contactTwoFirstName}
                />
              </Grid>

              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyLabelText
                  label={t('LAST_NAME')}
                  value={contactTwoLastName}
                />
              </Grid>

              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyLabelText
                  label={t('EMAIL_ID')}
                  value={contactTwoEmail}
                />
              </Grid>

              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyLabelText label={t('WORK')} value={contactTwoWork} />
              </Grid>

              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyLabelText
                  label={t('MOBILE')}
                  value={contactTwoMobile}
                />
              </Grid>
            </Grid>
          </Grid>
          <BakeasyDivider />

          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <BakeasyHeaderLabel message={t('CONTACT_ACCOUNTING')} />
            </Grid>
            <Grid container spacing={2} ml={2}>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyLabelText
                  label={t('FIRST_NAME')}
                  value={accountingFirstName}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyLabelText
                  label={t('LAST_NAME')}
                  value={accountingLastName}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyLabelText
                  label={t('EMAIL_ID')}
                  value={accountingEmail}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyLabelText label={t('WORK')} value={accountingWork} />
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyLabelText
                  label={t('MOBILE')}
                  value={accountingMobile}
                />
              </Grid>
            </Grid>
          </Grid>

          <BakeasyDivider />

          {isChainStore && (
            <>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
                  <BakeasyHeaderLabel message={t('CHAIN_STORE_PARENT')} />
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={3} xl={3}>
                  {/* <BakeasySwitch
                  label={'No / Yes'}
                  disabled={isView}
                  value={isChainStore}
                  onChange={(event: any) => {
                    event.stopPropagation();
                    setIsChainStore(event?.target?.checked);
                    handleChainStoreCheck(event?.target?.checked);
                  }}
                /> */}
                </Grid>

                <Grid container ml={2} spacing={2}>
                  <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                    <BakeasyLabelText
                      label={t('CHAIN_STORE_NAME')}
                      value={chainStoreName}
                    />
                  </Grid>

                  <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                    <BakeasyLabelText
                      label={t('PARENT_COUNTRY')}
                      // value={parentCountry}
                      value={
                        parentCountry?.countryName
                          ? t(
                              `${parentCountry.countryName.toUpperCase().replace(/\s+/g, '_')}`
                            )
                          : parentCountry
                      }
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                    <BakeasyLabelText
                      label={t('STATE_PROVINCE')}
                      // label={parentCountry?.countryName === 'Canada' ? 'PROVINCE' : 'PARENT_STATE'}
                      // value={parentState?.stateName ?? parentState}
                      value={
                        parentState?.stateName
                          ? t(
                              `${parentState.stateName.toUpperCase().replace(/\s+/g, '_')}`
                            )
                          : parentState
                      }
                    />
                  </Grid>

                  <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                    <BakeasyLabelText
                      label={t('PARENT_CITY')}
                      value={parentCity}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                    <BakeasyLabelText
                      label={t('PARENT_ADDRESS')}
                      value={parentAddress}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                    <BakeasyLabelText
                      label={t('PARENT_POSTAL_CODE')}
                      value={parentPostCode}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                    <BakeasyLabelText
                      label={t('PARENT_EMAIL_ID')}
                      value={parentEmailId}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                    <BakeasyLabelText
                      label={t('PARENT_WORK_NUMBER')}
                      value={parentWork}
                    />
                  </Grid>
                </Grid>
              </Grid>
              <BakeasyDivider />
            </>
          )}

          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <BakeasyHeaderLabel message={t('BILLING_DETAILS')} />
            </Grid>
            <Grid container spacing={2} ml={2}>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyLabelText
                  label={t('BILL_TO')}
                  value={
                    selectedBillTo
                      ? t(
                          `${selectedBillTo.toUpperCase().replace(/\s+/g, '_')}`
                        )
                      : selectedBillTo
                  }
                />
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyLabelText label={t('NAME')} value={billToName} />
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyLabelText
                  label={t('COMPANY_NAME')}
                  value={billToCompanyName}
                />
              </Grid>

              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyLabelText
                  label={t('COUNTRY')}
                  value={
                    billToCountry?.countryName
                      ? t(
                          `${billToCountry.countryName.toUpperCase().replace(/\s+/g, '_')}`
                        )
                      : billToCountry
                  }
                />
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyLabelText
                  label={t('STATE_PROVINCE')}
                  // label={billToCountry?.countryName === 'Canada' ? 'PROVINCE' : 'STATE'}
                  value={
                    billToState?.stateName
                      ? t(
                          `${billToState.stateName.toUpperCase().replace(/\s+/g, '_')}`
                        )
                      : billToState
                  }
                />
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyLabelText label={t('CITY')} value={billToCity} />
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyLabelText
                  label={t('COMPANY_ADDRESS')}
                  value={billToAddress}
                />
              </Grid>

              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyLabelText
                  label={t('POSTAL_CODE')}
                  value={billToPostCode}
                />
              </Grid>
            </Grid>
          </Grid>

          <BakeasyDivider />

          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <BakeasyHeaderLabel message={t('PAYMENT')} />
              </Grid>

              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Grid container spacing={2} pl={2}>
                  <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                    <BakeasyLabelText
                      label={t('METHOD')}
                      value={
                        selectedPaymentMethod?.paymentMethod
                          ? selectedPaymentMethod?.paymentMethod[i18n.language]
                          : ''
                      }
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                    <BakeasyLabelText
                      label={t('TERMS')}
                      value={
                        selectedPaymentTerm?.paymentTerms
                          ? selectedPaymentTerm?.paymentTerms[i18n.language]
                          : ''
                      }
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <BakeasyHeaderLabel message={t('BILLING')} />
              </Grid>

              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Grid container spacing={2} pl={2}>
                  <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                    <BakeasyLabelText
                      label={t('SETUP_FEE')}
                      value={
                        selectedBillingSetupFee?.setupFee
                          ? selectedBillingSetupFee?.setupFee[i18n.language]
                          : ''
                      }
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                    <BakeasyLabelText
                      label={t('SUBSCRIPTION_PACK')}
                      value={
                        selectedBillingSubscriptionPack?.subscriptionPack
                          ? selectedBillingSubscriptionPack?.subscriptionPack[
                              i18n.language
                            ]
                          : ''
                      }
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          <BakeasyDivider />

          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <BakeasyHeaderLabel message={t('TAXES')} />
              </Grid>

              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Grid container spacing={2} pl={2}>
                  <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                    <BakeasyLabelText
                      label={t('SUPPLIER_TAX1')}
                      value={selectedtaxrateOne?.taxName ?? selectedtaxrateOne}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                    <BakeasyLabelText
                      label={t('SUPPLIER_TAX2')}
                      value={selectedtaxrateTwo?.taxName ?? selectedtaxrateTwo}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                    <BakeasyLabelText
                      label={t('SUPPLIER_TAX1_RATE')}
                      value={
                        selectedtaxrateOne?.taxName
                          ? selectedtaxrateOne?.taxName?.split(' - ', 10).pop()
                          : ''
                      }
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                    <BakeasyLabelText
                      label={t('SUPPLIER_TAX2_RATE')}
                      value={
                        selectedtaxrateTwo?.taxName
                          ? selectedtaxrateTwo?.taxName?.split(' - ', 10).pop()
                          : ''
                      }
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <BakeasyHeaderLabel message={t('STATUS')} />
              </Grid>

              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Grid container spacing={2} pl={2}>
                  <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                    <BakeasyLabelText
                      label={t('STATUS')}
                      value={
                        //selectedStatus
                        selectedStatus
                          ? t(
                              `${selectedStatus?.toUpperCase().replace(/\s+/g, '_')}`
                            )
                          : selectedStatus
                      }
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                    <BakeasyCheckbox
                      disabled={isView}
                      label={t('RECIPE_BUILDER')}
                      value={recipeBuilder}
                      required={true}
                      onClick={(event: any) => {
                        setRecipeBuilder(event?.target?.checked);
                      }}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          <BakeasyDivider />
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <BakeasyHeaderLabel message={t('OTHER_DETAILS')} />
            </Grid>

            <Grid container spacing={2} ml={2}>
              <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                <BakeasyLabelText
                  label={t('DESCRIPTION')}
                  value={description}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                {supplierData?.supplierLogo && (
                  <BakeasyImgSelectorView
                    uploadState={'initFromProps'}
                    disabled={true}
                    onClick={() =>
                      openImageDialog(
                        'ViewImage',
                        t('SUPPLIER_LOGO'),
                        supplierData?.supplierLogo
                      )
                    }
                    id="supplierLogo"
                    value={supplierData?.supplierLogo}
                    label={t('SUPPLIER_LOGO')}
                    name="supplier-logo"
                    headerText={t('ACCEPTED_FORMATS')}
                    footerText={t('PLEASE_UPLOAD')}
                    onChange={(file: any) => {
                      //setSelectedSupplierLogoFile(file);
                    }}
                  />
                )}
              </Grid>
            </Grid>
          </Grid>

          {!isView && (
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              xl={12}
              sx={{ display: 'flex', justifyContent: 'space-between' }}
            >
              <Grid container sx={{ alignItems: 'end', justifyContent: 'end' }}>
                <Grid margin={1}>
                  <Button.Cancel
                    variant="outlined"
                    onClick={(event: React.MouseEvent<HTMLButtonElement>) => {
                      navigate(-1);
                    }}
                  />
                </Grid>

                <Grid margin={1}>
                  {isEdit ? (
                    <Button.Update
                      onClick={(event: React.MouseEvent<HTMLButtonElement>) => {
                        onSubmit();
                      }}
                    />
                  ) : (
                    <Button.Create
                      onClick={(event: React.MouseEvent<HTMLButtonElement>) => {
                        onSubmit();
                      }}
                    />
                  )}
                </Grid>
              </Grid>
            </Grid>
          )}
        </BakeasyPaper>
      </Grid>
    );
  }

  return isView ? ViewSupplierUI() : addSupplierUI();
};
